<template>
  <div class="page">
		<PageHeader>
			Генерация кошельков
		</PageHeader>

		<div class="content">
			
		</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getInfo, updateInfo } from '@/api'
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: 'Main',

	data: () => ({
		info: false
	}),

	mounted () {
		getInfo ()
			.then(response => {
				this.info = response.data.result
			})
	},

	methods: {
		Save () {
			updateInfo (this.info)
				.then(response => {
					alert('Успешно!')
				})
		}
	}
}
</script>

<style scoped>
.item {
	display: block;
	margin: 5px 0;
}

.item > label,
.item > input {
	display: inline-block;
}

.item > textarea {
	display: block;
	margin-top: 5px;
	padding: 7px;
	font-family: verdana;
	width: 95%;
	min-height: 250px;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/WalletGeneration/index.vue